import { observer } from "mobx-react-lite";

import { DefaultButton, Dialog, Stack } from "@bps/fluent-ui";
import { usePatientRecordScreenContext } from "@modules/clinical/screens/context/PatientRecordScreenContext.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const EncounterDeletedElsewhereDialog: React.FC = observer(() => {
  const { clinical } = useStores();
  const { clinicalRecord } = usePatientRecordScreenContext();

  // openEncounter will be undefined when encounterId is truthy if the GET request returned 404, indicating that the encounter was deleted
  // encountersDeletedElsewhere is used when the encounter is already loaded but was deleted in another browser window/tab
  const deletedElsewhere =
    (clinicalRecord.encounterId && !clinicalRecord.openEncounter) ||
    clinical.encountersDeletedElsewhere.find(
      x => x === clinicalRecord.encounterId
    );

  const showDialog =
    deletedElsewhere &&
    !clinicalRecord.finalisedByClient &&
    !clinicalRecord.encounterDiscardedByUser;

  const closeUnsavedFormsDialog = () => {
    clinical.removeDeletedElsewhereEncounter(clinicalRecord);
  };

  return (
    <Dialog minWidth={600} title="Deleted Elsewhere" hidden={!showDialog}>
      <Stack tokens={{ childrenGap: 16 }}>
        <Stack.Item> This Encounter has been deleted elsewhere. </Stack.Item>
        <Stack horizontalAlign="end">
          <DefaultButton onClick={() => closeUnsavedFormsDialog()}>
            Close
          </DefaultButton>
        </Stack>
      </Stack>
    </Dialog>
  );
});
